const SESSION_KEY = 'bv_mm_checkout_session'
const EMAIL_KEY = 'bv_mm_checkout_email'
const PURCHASE_KEY = 'bv_mm_checkout_purchase'

export type MmCheckoutStash = {
  checkoutSessionId: string
  buyerEmail: string
  /** One line per cart row (`qty× name` when qty > 1), for support / Discord paste. */
  purchaseSummary?: string
}

export function stashMmCheckoutContext(
  checkoutSessionId: string,
  buyerEmail: string,
  purchaseSummary?: string,
): void {
  try {
    sessionStorage.setItem(SESSION_KEY, checkoutSessionId.trim())
    sessionStorage.setItem(EMAIL_KEY, buyerEmail.trim())
    const p = purchaseSummary?.trim() ?? ''
    if (p) {
      sessionStorage.setItem(PURCHASE_KEY, p.slice(0, 4000))
    } else {
      sessionStorage.removeItem(PURCHASE_KEY)
    }
  } catch {
    // private mode / quota
  }
}

export function clearMmCheckoutContext(): void {
  try {
    sessionStorage.removeItem(SESSION_KEY)
    sessionStorage.removeItem(EMAIL_KEY)
    sessionStorage.removeItem(PURCHASE_KEY)
  } catch {
    /* ignore */
  }
}

/** Latest MoneyMotion checkout session (card flow). Does not remove — overwritten on next card checkout or cleared explicitly. */
export function readMmCheckoutContext(): MmCheckoutStash | null {
  try {
    const checkoutSessionId = sessionStorage.getItem(SESSION_KEY)?.trim()
    const buyerEmail = sessionStorage.getItem(EMAIL_KEY)?.trim() ?? ''
    if (!checkoutSessionId) return null
    const purchaseSummary = sessionStorage.getItem(PURCHASE_KEY)?.trim() || undefined
    return { checkoutSessionId, buyerEmail, purchaseSummary }
  } catch {
    return null
  }
}
